import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { adminCss } from "./styles";

const style = document.createElement("style");
style.textContent = adminCss;
document.head.append(style);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
